import { __assign } from "tslib";
import * as React from 'react';
function IconEmailSizeXs(props) {
    return (React.createElement("svg", __assign({ viewBox: "0 0 16 16" }, props),
        React.createElement("path", { d: "M14 4.3V12C14 12.5128 13.614 12.9355 13.1166 12.9933L13 13H3.00001C2.48718 13 2.06451 12.614 2.00674 12.1166L2 12V4.3L7.34151 8.75259C7.71854 9.08249 8.28149 9.08249 8.65852 8.75259L14 4.3ZM12.433 3L8.00001 6.67125L3.566 3H12.433Z" })));
}
export default IconEmailSizeXs;
